import { render, staticRenderFns } from "./SettingsWorkspaceEdit.vue?vue&type=template&id=c06ea5c4"
import script from "./SettingsWorkspaceEdit.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspaceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports